import { render, staticRenderFns } from "./netbank-login.pug?vue&type=template&id=16567692&lang=pug&external"
import script from "./netbank-login.js?vue&type=script&lang=js&external"
export * from "./netbank-login.js?vue&type=script&lang=js&external"
import style0 from "./netbank-login-placeholder.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./netbank-login.scss?vue&type=style&index=1&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports